<template>
  <div>
    <!-- Start: Content -->
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link to="/report/inquiry">
                        Manage Booking
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Summary
                    </li>
                  </ol>
                </nav>
                <h4>Booking Details</h4>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>
              </div>
              <div class="label-group" v-if="detail.progress !== 'Abort'">
                <div class="label">Payment Status</div>
                <div class="label-title">
                  <span
                    v-if="detail.paymentStatus === 'Complete'"
                    class="--green35"
                    >Completed</span
                  >
                  <span v-else class="sts-danger">{{
                    humanize(detail.paymentStatus)
                  }}</span>
                </div>
              </div>
              <div
                class="label-group"
                v-if="detail.paymentStatus === 'Complete'"
              >
                <div class="label">Payment Method</div>
                <div class="label-title">
                  <span>{{ detail.paymentMethod }}</span>
                </div>
              </div>
              <div class="label-group" v-if="detail.progress === 'Abort'">
                <div class="label">Reservation Status</div>
                <div class="label-title">
                  <span class="sts-danger">{{
                    humanize(detail.progress)
                  }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ detail.code }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>{{ detail.reservationDate.stringFullDate }} </span>
                </div>
              </div>
              <div class="label-group" v-if="detail.driver">
                <div class="label">Driver Name</div>
                <div class="label-title --green">
                  <span
                    >{{ detail.driver.title }}.
                    {{ detail.driver.fullName }}</span
                  >
                </div>
              </div>
              <div class="label-group" v-if="detail.driver">
                <div class="label">Driver Phone</div>
                <div class="label-title">
                  <span>{{
                    detail.driver.phoneCode && detail.driver.phoneNumber
                      ? `(+${detail.driver.phoneCode}) ${detail.driver.phoneNumber}`
                      : "N/A"
                  }}</span>
                </div>
              </div>
              <div
                class="label-group"
                v-if="
                  detail.paymentStatus !== 'Complete' &&
                  detail.paymentStatus !== 'Invoiced'
                "
              >
                <div class="label" style="color: red">
                  Your reservation will be confirmed once full payment is made.
                </div>
              </div>
            </div>
            <div class="body--reservation-detail">
              <div class="row">
                <div class="col-sm-6">
                  <i class="ic-businessmen --green pull-left mr-10"></i>
                  <h4 class="--green">Passenger Details</h4>
                  <!-- <div class="label-group">
                    <div class="label">Company</div>
                    <div class="label-title">
                      {{ detail.passengers[0].companyName }}
                    </div>
                  </div> -->
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ detail.passengers[0].title }}.
                      {{ detail.passengers[0].fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        detail.passengers[0].phoneCode &&
                        detail.passengers[0].phoneNumber
                          ? `(+${detail.passengers[0].phoneCode}) ${detail.passengers[0].phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{
                        detail.passengers[0].email
                          ? detail.passengers[0].email
                          : "N/A"
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 divider-left text-right">
                  <h4>Booker</h4>
                  <!-- <div class="label-group">
                    <div class="label">Company</div>
                    <div class="label-title">
                      {{ detail.booker.companyName }}
                    </div>
                  </div> -->
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ detail.booker.title }}. {{ detail.booker.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        detail.booker.phoneCode && detail.booker.phoneNumber
                          ? `(+${detail.booker.phoneCode}) ${detail.booker.phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{ detail.booker.email ? detail.booker.email : "N/A" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="passenger-flight-info">
              <div v-if="detail.flightInfo">
                <h4>Passenger Flight Info</h4>
                <div class="row">
                  <div class="col-sm-8">
                    <div class="--green passenger__flight">
                      {{ detail.flightInfo.carrierName }}
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="passenger__flight-number">
                      {{ detail.flightInfo.carrierCode }}-{{
                        detail.flightInfo.flightNumber
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="detail.notes && detail.notes.length > 0">
                <h6>Notes</h6>
                <div
                  class="passenger-notes"
                  v-for="(note, index) in detail.notes"
                  :key="index"
                >
                  {{ detail.notes.length > 1 ? `${index + 1}.` : "" }}
                  {{ note }}
                </div>
              </div>
            </div>
            <div class="box-addons mt-20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading text-center">
                    <h4 class="panel-title">
                      <a
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapse1"
                        class="--green"
                      >
                        <i class="ic-History mr-10"></i>Reservation History
                      </a>
                    </h4>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <div class="trip-info">
                        <div
                          v-for="(history, index) in detail.histories"
                          :key="index"
                        >
                          <div class="col-sm-3">
                            <div class="time__depart">
                              <div class="time_Is">
                                {{ history.createdDate.stringHour }}:{{
                                  history.createdDate.stringMinute
                                }}
                              </div>
                              <div class="date_Is">
                                {{ history.createdDate.stringDate }}
                                {{ history.createdDate.stringShortMonth }}
                                {{ history.createdDate.year }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-9">
                            <div
                              :class="[
                                index === detail.histories.length - 1
                                  ? 'end-time-stamp'
                                  : 'time-stamp',
                                history.event.toLowerCase().includes('dropped')
                                  ? 'dropped'
                                  : '',
                              ]"
                            >
                              <div class="stamp-status --green">
                                {{ humanize(history.event) }}
                              </div>
                              <div
                                class="stamp-desc"
                                v-html="getEventDescription(history)"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="price-detail-header">
              <div class="grand-total">
                <table class="table table-amount">
                  <thead>
                    <tr>
                      <th class="text-left --green">Total Amount</th>
                      <th class="text-right">
                        {{ detail.currencyCode }}
                        {{ printMoney(detail.grandTotal) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">Base</td>
                      <td class="text-right">
                        <strong>{{ printMoney(detail.baseFare) }}</strong>
                      </td>
                    </tr>
                    <tr v-if="detail.surchargeTotal > 0">
                      <td class="text-left">Surcharge</td>
                      <td class="text-right">
                        <strong>{{ printMoney(detail.surchargeTotal) }}</strong>
                      </td>
                    </tr>
                    <tr v-if="detail.ancillaryTotal > 0">
                      <td class="text-left">Ancillary</td>
                      <td class="text-right">
                        <strong>{{ printMoney(detail.ancillaryTotal) }}</strong>
                      </td>
                    </tr>
                    <tr v-if="ancillaries && ancillaries.length > 0">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(ancillary, index) in ancillaries"
                            :key="index"
                          >
                            {{ ancillary.name
                            }}<span>x{{ ancillary.quantity }}</span
                            ><span class="value">{{
                              printMoney(ancillary.rate)
                            }}</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="isHaveExtra">
                      <td class="text-left">Post-Booking Extras</td>
                      <td class="text-right">
                        <span class="value" v-if="totalExtraService > 0">
                          <strong>{{ printMoney(totalExtraService) }}</strong>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="isHaveExtra">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(
                              service, index
                            ) in fareComponents.postBooking"
                            :key="index"
                          >
                            {{ service.name
                            }}<span>x{{ service.quantity }}</span
                            ><span
                              class="value"
                              v-if="service.rate * service.quantity > 0"
                              >{{
                                printMoney(service.rate * service.quantity)
                              }}</span
                            >
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- Start: Refund -->
                <div
                  class="reservation-button pl-5-pr-5"
                  v-if="
                    hasPaid &&
                    detail.progress !== 'Abort' &&
                    !isJobComplete &&
                    isRefundable
                  "
                >
                  <button
                    class="btn btn-block btn-nobg"
                    @click="openCancelDialog()"
                  >
                    Cancel
                  </button>
                </div>
                <!-- End: Refund -->
                <!-- Start: PayNow/Cancel/Feedback -->
                <div
                  class="reservation-button pl-5 pr-5"
                  v-if="showMoreActionButton || showPayButton"
                >
                  <div class="dropdown" v-if="showPayButton">
                    <button
                      class="btn btn-default dropdown-toggle --white"
                      type="button"
                      id="dropdownMenu1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                      :style="[
                        showMoreActionButton
                          ? { width: '300px' }
                          : { width: '400px' },
                      ]"
                    >
                      Pay now
                      <span class="caret --white"></span>
                    </button>
                    <ul
                      class="dropdown-menu payment-method"
                      aria-labelledby="dropdownMenu1"
                    >
                      <li>
                        <a
                          v-if="detail.paymentConfig.isEnableCorporateAccount"
                          @click="openDepositPaymentDialog()"
                        >
                          Corporate Account
                        </a>
                        <a
                          v-if="
                            detail.paymentConfig &&
                            detail.paymentConfig.isEnablePaymentGateway
                          "
                          @click="payWithCreditCard()"
                        >
                          Credit Card
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="dropdown" v-if="showMoreActionButton">
                    <button
                      class="btn btn-default dropdown-toggle btn-block"
                      type="button"
                      id="dropdownMenu1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                      :style="[showPayButton ? {} : { width: '400px' }]"
                    >
                      {{ hasPaid ? "Payment submitted" : "..." }}
                    </button>
                    <ul
                      class="dropdown-menu other-action"
                      aria-labelledby="dropdownMenu1"
                    >
                      <li v-if="isPassengerDropped">
                        <a @click="openFeedbackDialog()">Feedback</a>
                      </li>
                      <li v-if="detail.progress !== 'Abort'">
                        <a @click="openAdditionalNotesDialog()">Notes</a>
                      </li>
                      <li v-if="!hasPaid && detail.progress !== 'Abort'">
                        <a @click="openCancelDialog()">Cancel</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- End: PayNow/Cancel/Feedback -->
              </div>
            </div>
            <div class="reservation-summary--small">
              <div class="dropandpickup cRow">
                <div class="col-sm-6 plz">
                  <div class="location-pick-up" :title="pickUpLocation">
                    {{ pickUpLocation }}
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="onClickOpenDetailLocation(detail.pickUpLocation)"
                    class="--green"
                  >
                    View pick-up point
                  </a>
                  <div class="row">
                    <div class="col-sm-5 prz">
                      <div class="rent-date">
                        {{ detail.pickUpDate.stringDate }}
                        {{ detail.pickUpDate.stringShortMonth }}
                      </div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ pickUpTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 prz divider-left">
                  <div
                    class="location-drop-off text-right"
                    :title="dropOffLocation"
                  >
                    {{ dropOffLocation }}
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="onClickOpenDetailLocation(detail.dropOffLocation)"
                    class="text-right --green"
                  >
                    View drop-off point
                  </a>
                  <div class="row" v-if="isAirportTransfer">
                    <div class="col-sm-12 text-right">
                      <div class="rent-date">---</div>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-sm-5 prz">
                      <div class="rent-date">
                        {{ detail.dropOffDate.stringDate }}
                        {{ detail.dropOffDate.stringShortMonth }}
                      </div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ dropOffTime }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cRow">
                <template v-if="detail.searchMode === 'OnDemand'">
                  <div class="col-sm-7">
                    <img
                      :src="detail.vehicle.imageUri"
                      class="cars-image"
                      alt
                    />
                  </div>
                  <div class="col-sm-5">
                    <div class="provider-img">
                      <img :src="detail.provider.imageUri" alt />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-12">
                    <img
                      :src="detail.vehicle.imageUri"
                      class="cars-image"
                      alt
                    />
                  </div>
                </template>
              </div>

              <div
                class="provider-box cRowen-col"
                v-if="detail.searchMode === 'OnDemand'"
              >
                <div class="provider-name">{{ detail.provider.name }}</div>
                <!-- <button
                  class="btn btn-info"
                  data-toggle="modal"
                  data-target="#terms-modal"
                >
                  Rental Terms
                </button> -->
              </div>

              <!-- <div class="row cRow">
                <div class="col-sm-12">
                  <img :src="detail.vehicle.imageUri" class="cars-image" alt />
                </div>
              </div> -->

              <!-- <div class="provider-box cRowen-col">
                <button
                  class="btn btn-info"
                  data-toggle="modal"
                  data-target="#terms-modal"
                >
                  <strong>Rental Terms</strong>
                </button>
              </div> -->
              <div class="type-car">{{ detail.vehicle.className }}</div>
              <div class="cars-brand">
                {{ detail.vehicle.factoryName }} {{ detail.vehicle.brandName }}
                {{
                  detail.vehicle.plateNumber
                    ? `(${detail.vehicle.plateNumber})`
                    : ""
                }}
              </div>
              <div
                class="row"
                v-if="
                  hasPaxCapacity ||
                  hasLargeBaggageCapacity ||
                  hasSmallBaggageCapacity
                "
              >
                <div class="col-sm-7">
                  <div class="capacity-seat" v-if="hasPaxCapacity">
                    Pax Capacity {{ detail.vehicle.feature.paxCapacity }}
                  </div>
                  <div
                    class="capacity-large-baggage"
                    v-if="hasLargeBaggageCapacity"
                  >
                    Large Bag. Capacity x{{
                      detail.vehicle.feature.largeBaggageCapacity
                    }}
                  </div>
                  <div class="capacity-baggage" v-if="hasSmallBaggageCapacity">
                    Small Bag. Capacity x{{
                      detail.vehicle.feature.smallBaggageCapacity
                    }}
                  </div>
                </div>
                <!-- <div class="col-sm-5 text-right">
                  <div class="reschedule" v-if="isRescheduleAvailable"></div>
                  <div class="free-cancelation" v-if="isRefundable"></div>
                </div>-->
              </div>
              <div class="price-summary">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="operation with-driver"></div>
                  </div>
                  <div class="col-sm-6 text-right">
                    <div class="label-price"><span>Total Amount</span></div>
                    <div class="price-value">
                      {{ detail.currencyCode }}
                      {{ printMoney(detail.grandTotal + totalExtraService) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .reservation-summary--small -->
            <a class="btn btn-primary hidden" @click="confirm()">CONFIRM</a>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" id="termsmodal">
      <div class="modal-dialog modal-md">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-left">
            <h4 class="--green">
              <strong>Important Information!</strong>
            </h4>
          </div>
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="terms-body">
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-personal"></i>
                  </div>
                  <h5>
                    Driving &amp; License
                    <span>Requirements</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fuga omnis reiciendis exercitationem accusantium ipsum cum
                    quae nihil voluptatum libero aliquid nam deserunt, deleniti
                    eius animi eos at, porro unde? Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-corporate-card"></i>
                  </div>
                  <h5>
                    Security Deposit
                    <span>US$ 35.00</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fuga omnis reiciendis exercitationem accusantium ipsum cum
                    quae nihil voluptatum libero aliquid nam deserunt, deleniti
                    eius animi eos at, porro unde? Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-car"></i>
                  </div>
                  <h5>
                    Damage Access
                    <span>US$ 35.00</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fuga omnis reiciendis exercitationem accusantium ipsum cum
                    quae nihil voluptatum libero aliquid nam deserunt, deleniti
                    eius animi eos at, porro unde? Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-manage-trip"></i>
                  </div>
                  <h5>
                    Mileage
                    <span>Unlimited</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fuga omnis reiciendis exercitationem accusantium ipsum cum
                    quae nihil voluptatum libero aliquid nam deserunt, deleniti
                    eius animi eos at, porro unde? Aut.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="feedbackmodal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10"><h4>Feedback for Driver</h4></div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" role="form" id="feedbackform">
                    <div class="form-group">
                      <label class="required">Comment</label>
                      <textarea
                        class="form-control"
                        rows="4"
                        name="customerFeedback"
                        v-model="customerFeedback"
                        :readonly="hasFeedback"
                        maxlength="300"
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="
                          customerFeedback !== null && customerFeedback !== ''
                        "
                      >
                        {{ customerFeedback.length }} from 300 characters
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.customerFeedback"
                        v-text="validationErrors.customerFeedback"
                      ></small>
                    </div>
                    <div class="form-group">
                      <label>Rating</label>
                      <vue-stars
                        v-model="driverRating"
                        v-bind:readonly="hasFeedback"
                      />
                    </div>
                    <div class="modal-footer" v-if="!hasFeedback">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="postFeedback()"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="notesmodal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10"><h4>Additional Notes</h4></div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" role="form" id="notesform">
                    <div class="form-group">
                      <label class="required">Notes</label>
                      <textarea
                        class="form-control"
                        rows="4"
                        name="additionalNotes"
                        v-model="additionalNotes"
                        maxlength="400"
                        required
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="
                          additionalNotes !== null && additionalNotes !== ''
                        "
                      >
                        {{ additionalNotes.length }} from 400 characters
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.additionalNotes"
                        v-text="validationErrors.additionalNotes"
                      ></small>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="postNotes()"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="cancelreasonmodal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10"><h4>Cancel Reservation</h4></div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" role="form" id="cancelform">
                    <div class="form-group mbz">
                      <div>
                        <strong>Tell us why you are cancelling.</strong>
                      </div>
                      <div class="btn-group-radio btn-group-newline">
                        <label
                          class="wrap-radio"
                          v-for="(item, index) in reasons"
                          @click="onClickReasonCode(item)"
                          :key="index"
                        >
                          {{ item.text }}
                          <input
                            type="radio"
                            name="reasonCode"
                            :value="item.value"
                            v-model="reasonCode"
                          />
                          <span class="bullet-mark"></span>
                        </label>
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.reasonCode"
                        v-text="validationErrors.reasonCode"
                      ></small>
                    </div>
                    <div class="form-group" v-if="reasonCode === '5'">
                      <textarea
                        class="form-control"
                        rows="4"
                        name="reasonWord"
                        v-model="reasonWord"
                        maxlength="300"
                        required
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="reasonWord && reasonWord !== ''"
                      >
                        {{ reasonWord.length }} from 300 characters
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.reasonWord"
                        v-text="validationErrors.reasonWord"
                      ></small>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="cancelReservation()"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <mapModal />
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :id="'depositconfirmation'"
      :header="'Pay now?'"
      :content="depositPaymentMessage"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      @submit="payWithDeposit"
    />
    <confirmModal
      :id="'depositinsufficientconfirmation'"
      :header="'Pay now?'"
      :content="depositInsufficientMessage"
      :cancel-label="'OK'"
    />
    <confirmModal
      :id="'cancalconfirmation'"
      :header="'Cancel Booking?'"
      :content="'There may be a cancellation charge applied to this booking. Kindly check the booking conditions.'"
      :cancel-label="'Stay'"
      :submit-label="'Yes, Cancel'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="openCancelReasonDialog"
    />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import mapModal from "@/components/shared/MapModal";
import confirmModal from "@/components/shared/ConfirmModal";
import maverickMap from "@/plugins/google/map.js";
import instantReservationService from "@/services/shop/reservation/instantReservationService.js";
import paymentService from "@/services/shop/paymentService.js";
import reservationService from "@/services/shop/reservationService.js";
import depositService from "@/services/master/deposit/depositSummaryService.js";

export default {
  components: {
    mapModal,
    confirmModal,
  },
  data() {
    return {
      isLoading: false,
      msg: "Please wait",
      moneyFormat: null,
      rentDays: null,
      customerFeedback: null,
      additionalNotes: null,
      reasonWord: null,
      reasonCode: null,
      depositPaymentMessage: null,
      depositInsufficientMessage: null,
      map: null,
      driverRating: 0,
      totalExtraService: 0,
      isHaveExtra: false,
      validationErrors: {
        reasonWord: null,
        customerFeedback: null,
        additionalNotes: null,
      },
      detail: {},
      fareComponents: {},
      ancillaries: [],
      reasons: [],
    };
  },
  computed: {
    hasFeedback: function () {
      // return this.detail && this.detail.feedback !== null;
      return false;
    },
    isRefundable: function () {
      return (
        this.detail &&
        this.detail.histories.find(
          (x) => x.event.toLowerCase() === "driverpickup"
        ) === undefined &&
        this.detail.paymentStatus &&
        this.detail.paymentStatus !== "RefundRequested"
      );
    },
    isJobComplete: function () {
      return this.detail && this.detail.progress === "Close";
    },
    isPassengerDropped: function () {
      return (
        this.detail.histories &&
        this.detail.histories.find(
          (x) => x.event.toLowerCase() === "passengerdropped"
        )
      );
    },
    hasPaid: function () {
      return (
        this.detail &&
        this.detail.paymentStatus &&
        (this.detail.paymentStatus === "Complete" ||
          this.detail.remainingPayment === 0)
      );
    },
    pickUpLocation: function () {
      return this.detail &&
        this.detail.pickUpLocation &&
        this.detail.pickUpLocation.location
        ? this.detail.pickUpLocation.location.name
        : "";
    },
    dropOffLocation: function () {
      return this.detail &&
        this.detail.dropOffLocation &&
        this.detail.dropOffLocation.location &&
        this.detail.dropOffLocation.location.name !== this.pickUpLocation
        ? this.detail.dropOffLocation.location.name
        : "Same Location";
    },
    pickUpTime: function () {
      return (
        this.detail &&
        this.detail.pickUpDate.hour +
          ":" +
          (this.detail.pickUpDate.minute < 10
            ? this.detail.pickUpDate.minute + "0"
            : this.detail.pickUpDate.minute)
      );
    },
    dropOffTime: function () {
      return (
        this.detail &&
        this.detail.dropOffDate.hour +
          ":" +
          (this.detail.dropOffDate.minute < 10
            ? this.detail.dropOffDate.minute + "0"
            : this.detail.dropOffDate.minute)
      );
    },
    isAirportTransfer: function () {
      return (
        this.detail &&
        this.detail.serviceType &&
        this.detail.serviceType === "AirportTransfer"
      );
    },
    hasPaxCapacity: function () {
      return (
        this.detail &&
        this.detail.vehicle &&
        this.detail.vehicle.feature &&
        this.detail.vehicle.feature.paxCapacity &&
        parseInt(this.detail.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.detail &&
        this.detail.vehicle &&
        this.detail.vehicle.feature &&
        this.detail.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.detail.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.detail &&
        this.detail.vehicle &&
        this.detail.vehicle.feature &&
        this.detail.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.detail.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    showPayButton: function () {
      return !this.hasPaid && this.detail.progress !== "Abort";
    },
    showMoreActionButton: function () {
      return (
        this.isPassengerDropped ||
        this.detail.progress !== "Abort" ||
        this.showPayButton
      );
    },
  },
  async created() {
    this.$helper.scrollTop();
    await this.getById();

    this.reasons = [
      { value: "1", text: "Entered wrong location" },
      { value: "2", text: "Changes to the travel plans " },
      { value: "3", text: "Not enough space in the vehicle " },
      { value: "4", text: "Entered wrong information" },
      { value: "5", text: "Others" },
    ];
  },
  mounted() {
    if (!this.map) {
      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: -6.17003832454938,
        lng: 106.81490242481232,
        infoWindow: true,
      });
      this.map.initialize();
    }
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    onClickOpenDetailLocation(detail) {
      this.map.showInfoWindow(
        {
          latitude: detail.location.latitude,
          longitude: detail.location.longitude,
        },
        detail.location.address
      );
      $(this.$refs.mapmodal).modal();
    },
    async getById() {
      try {
        this.isLoading = true;
        this.detail = await instantReservationService.getById(
          this.$route.params.id
        );
        this.rentDays = this.detail.rentDays;
        this.moneyFormat = this.detail.moneyFormat;

        // if (this.hasFeedback) {
        //   this.customerFeedback = this.detail.feedback.comment;
        //   this.driverRating = this.detail.feedback.score;
        // }

        if (
          this.detail.fareComponents &&
          this.detail.fareComponents.length > 0
        ) {
          let fareComponents = Array.prototype.slice.call(
            this.detail.fareComponents,
            0
          );
          this.ancillaries = fareComponents.filter(
            (x) =>
              x.category === "Selling" &&
              ["Ancillary", "Extra"].includes(x.type) &&
              x.isPreBooking
          );
          this.fareComponents.preBooking = fareComponents.filter(
            (f) => f.category === "Selling" && f.isPreBooking
          );
          this.fareComponents.postBooking = fareComponents.filter(
            (f) => f.category === "Selling" && !f.isPreBooking
          );
          this.totalExtraService = this.fareComponents.postBooking.reduce(
            (accum, item) => accum + item.quantity * item.rate,
            0
          );
          if (this.fareComponents.postBooking.length > 0) {
            this.isHaveExtra = true;
          }
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async confirm() {
      if (confirm("Are you sure you want to confirm this reservation?")) {
        try {
          this.isLoading = true;
          await instantReservationService.confirm({
            id: this.detail.id,
          });
          this.$notification.success("Successfully confirmed.", {
            title: "Success",
          });
          this.detail = await instantReservationService.getById(this.detail.id);
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
    // async refund() {
    //   if (confirm("Are you sure you want to refund this reservation?")) {
    //     try {
    //       this.isLoading = true;
    //       await instantReservationService.refund({
    //         id: this.detail.id,
    //       });
    //       this.$notification.success("Successfully refunded.", { title: "Success" });
    //       this.detail = await instantReservationService.getById(this.detail.id);
    //     } catch (error) {
    //       if (error.errors) {
    //         for (let index = 0; index < error.errors.length; index++) {
    //           this.$notification.error(error.errors[index], { title: "Error" });
    //         }
    //       }
    //     } finally {
    //       this.isLoading = false;
    //     }
    //   }
    // },
    openDepositPaymentDialog() {
      if (this.detail.depositBalance >= this.detail.grandTotal) {
        this.depositPaymentMessage =
          this.detail.depositBalance !== null
            ? `Your current balance is<br/><strong>${
                this.detail.currencyCode
              } ${this.printMoney(this.detail.depositBalance)}</strong>`
            : "";
        $("#depositconfirmation").modal({
          backdrop: "static",
          keyboard: false,
        });
      } else {
        this.depositInsufficientMessage =
          this.detail.depositBalance !== null
            ? `Your current balance of <strong>${
                this.detail.currencyCode
              } ${this.printMoney(
                this.detail.depositBalance
              )}</strong> is insufficient. Please top up funds to your company credit or select another payment method to confirm your booking.`
            : "";
        $("#depositinsufficientconfirmation").modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    },
    async payWithDeposit() {
      try {
        this.isLoading = true;
        await depositService.inquiryDeduct({
          isInquiry: true,
          reservationId: this.detail.id,
        });
        this.$router.push({
          path: "/payment/deposit/redirect",
        });
      } catch (error) {
        this.isLoading = false;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async payWithCreditCard() {
      try {
        this.isLoading = true;
        const response = await paymentService.generateUrl({
          isInquiry: false,
          reservationId: this.detail.id,
        });
        if (response && response.isSuccess) {
          window.open(response.data.url, "_self");
        } else {
          this.isLoading = false;
          this.$notification.error("Failed generating payment url.");
        }
      } catch (error) {
        this.isLoading = false;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    openCancelDialog() {
      $("#cancalconfirmation").modal({ backdrop: "static", keyboard: false });
    },
    openCancelReasonDialog() {
      this.validationErrors.reasonWord = null;
      this.onClickReasonCode(this.reasons[0]);
      $(this.$refs.cancelreasonmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    onClickReasonCode(item) {
      this.reasonCode = item.value;
      this.reasonWord = item.text;
      if (this.reasonCode === "5") {
        this.reasonWord = null;
      }
    },
    async cancelReservation() {
      if (!this.$helper.validateForm(this, "cancelform")) {
        return;
      }

      const payload = {
        reservationId: this.detail.id,
        reason: this.reasonWord,
      };
      const response = await reservationService.cancel(
        payload,
        this.startLoader
      );

      if (response.isSuccess) {
        $(this.$refs.cancelreasonmodal).modal("hide");
        await this.getById();
        this.$notification.success("Successfully canceled.", {
          title: "Success",
        });
      } else {
        this.stopLoader();
      }
    },
    openFeedbackDialog() {
      this.validationErrors.customerFeedback = null;
      $(this.$refs.feedbackmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async postFeedback() {
      if (!this.$helper.validateForm(this, "feedbackform")) {
        return;
      }

      const payload = {
        reservationId: this.detail.id,
        comment: this.customerFeedback,
        score: this.driverRating,
      };

      const response = await reservationService.postFeedback(
        payload,
        this.startLoader
      );

      this.detail.feedback = {
        comment: this.customerFeedback,
        score: this.driverRating,
      };

      if (response.isSuccess) {
        $(this.$refs.feedbackmodal).modal("hide");
        await this.getById();
        this.$notification.success("Successfully send feedback.", {
          title: "Success",
        });
      } else {
        this.stopLoader();
      }
    },
    openAdditionalNotesDialog() {
      this.validationErrors.additionalNotes = null;
      this.additionalNotes = null;
      $(this.$refs.notesmodal).modal({ backdrop: "static", keyboard: false });
    },
    async postNotes() {
      if (!this.$helper.validateForm(this, "notesform")) {
        return;
      }

      const payload = {
        reservationId: this.detail.id,
        notes: this.additionalNotes,
      };
      const response = await reservationService.postNote(
        payload,
        this.startLoader
      );

      if (response.isSuccess) {
        $(this.$refs.notesmodal).modal("hide");
        await this.getById();
        this.$notification.success("Successfully send notes.", {
          title: "Success",
        });
      } else {
        this.stopLoader();
      }
    },
    getEventDescription(history) {
      return this.$helper.getEventDescription(history);
    },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>

<style scoped>
.vue-stars label {
  font-size: 25px;
}

.payment-method:hover,
.other-action:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/instant/ReservationSummary.vue